var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 880,
    height: 813.325,
    viewBox: "0 0 880 813.325",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(-519.736 -95.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1317-3070",
    "data-name": "Path 1317",
    d: "M1017,290.71V500.618c0,171.111-138.711,309.815-309.814,309.806H137V600.516c0-112.167,59.614-210.421,148.9-264.789A307.506,307.506,0,0,1,334.249,311.8a304.183,304.183,0,0,1,30.182-10.007c.2-.066.409-.124.608-.171q4.533-1.24,9.123-2.338c.171-.047.333-.086.5-.124a309.914,309.914,0,0,1,57.466-8.106c2.29-.1,4.581-.19,6.89-.238.827-.029,1.663-.048,2.509-.048q2.623-.057,5.274-.057Z",
    transform: "translate(382.736 97.691)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_241",
    "data-name": "Ellipse 241",
    cx: 73.736,
    cy: 73.736,
    r: 73.736,
    transform: "translate(1192.498 97.316)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259-3071",
    "data-name": "Path 1259",
    d: "M692.929,242.723c-75.14-.007-134-13.629-134-31.012,0-10.422,20.858-19.719,57.222-25.506a1,1,0,0,1,.331,1.972h0l-.013,0c-34.255,5.452-55.536,14.469-55.537,23.531,0,15.72,60.446,29.005,132,29.012s132-13.268,132-28.988c0-9.1-21.414-18.143-55.888-23.6a1,1,0,1,1,.3-1.977h.01c36.591,5.79,57.576,15.111,57.575,25.574C826.93,229.118,768.069,242.73,692.929,242.723Z",
    transform: "translate(572.805 -34.935)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260-3072",
    "data-name": "Path 1260",
    d: "M698.284,230.811c-64.749,38.126-122.378,56.258-131.2,41.278-5.288-8.981,7.966-27.576,36.363-51.017a1,1,0,0,1,1.286,1.532l0,0-.01.008c-26.75,22.082-40.511,40.65-35.913,48.459,7.976,13.546,66.8-5.682,128.461-41.987s107.008-78.42,99.031-91.966c-4.618-7.842-27.659-4.766-60.132,8.028a1,1,0,0,1-.743-1.857h0l.007,0c34.467-13.58,57.28-16.2,62.588-7.182C806.845,151.086,763.033,192.685,698.284,230.811Z",
    transform: "translate(572.805 -34.935)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281-3073",
    "data-name": "Path 1281",
    d: "M382.585,292.883h-1.82v-1.82a2.34,2.34,0,0,0-4.68-.009v1.829h-1.82a2.34,2.34,0,1,0-.008,4.68h1.828v1.82a2.34,2.34,0,1,0,4.68.009v-1.829h1.82a2.34,2.34,0,0,0,.008-4.68h0Z",
    transform: "translate(360 90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283-3074",
    "data-name": "Path 1283",
    d: "M1017,290.71V500.618c0,171.111-138.711,309.815-309.814,309.806H137V600.516c0-112.167,59.614-210.421,148.9-264.789A307.506,307.506,0,0,1,334.249,311.8a304.183,304.183,0,0,1,30.182-10.007c.2-.066.409-.124.608-.171q4.533-1.24,9.123-2.338c.171-.047.333-.086.5-.124a309.914,309.914,0,0,1,57.466-8.106c2.29-.1,4.581-.19,6.89-.238.827-.029,1.663-.048,2.509-.048q2.623-.057,5.274-.057Z",
    transform: "translate(382.736 97.691)",
    fill: "#6c63ff",
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284-3075",
    "data-name": "Path 1284",
    d: "M958.071,795.924H137.01c0-.274.009-.54.029-.814,2.528-55.255,185.342-99.86,410.5-99.86,150.417,0,281.942,19.9,353.435,49.6C937.021,759.821,957.814,777.276,958.071,795.924Z",
    transform: "translate(382.736 113.293)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(584.357 887.15)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1285-3076",
    "data-name": "Path 1285",
    d: "M357.052,836.646a6.308,6.308,0,0,1-.076.95h-151.9a6.3,6.3,0,0,1-.076-.95.816.816,0,0,1,.01-.152c.285-11.594,34.212-20.964,76.016-20.964s75.731,9.37,76.016,20.964a.817.817,0,0,1,.009.152Z",
    transform: "translate(-205 -815.53)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(858.052 808.543)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_251",
    "data-name": "Ellipse 251",
    cx: 76.026,
    cy: 21.118,
    rx: 76.026,
    ry: 21.118
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(591.961 889.26)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1286-3077",
    "data-name": "Path 1286",
    d: "M349.847,836.756a5.356,5.356,0,0,1-.086.95H213.085a5.353,5.353,0,0,1-.085-.95.815.815,0,0,1,.009-.152c.285-10.435,30.809-18.854,68.414-18.854s68.129,8.42,68.414,18.854a.814.814,0,0,1,.009.152Z",
    transform: "translate(-213 -817.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(865.654 810.655)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_252",
    "data-name": "Ellipse 252",
    cx: 68.423,
    cy: 19.006,
    rx: 68.423,
    ry: 19.006
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(1170.518 868.828)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_253",
    "data-name": "Ellipse 253",
    cx: 49.607,
    cy: 13.78,
    rx: 49.607,
    ry: 13.78
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(1175.479 870.207)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_254",
    "data-name": "Ellipse 254",
    cx: 44.646,
    cy: 12.402,
    rx: 44.646,
    ry: 12.402
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_255",
    "data-name": "Ellipse 255",
    cx: 6.652,
    cy: 6.652,
    r: 6.652,
    transform: "translate(644.229 466.366)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_256",
    "data-name": "Ellipse 256",
    cx: 6.652,
    cy: 6.652,
    r: 6.652,
    transform: "translate(1216.324 726.755)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_258",
    "data-name": "Ellipse 258",
    cx: 3.801,
    cy: 3.801,
    r: 3.801,
    transform: "translate(1235.33 475.87)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_259",
    "data-name": "Ellipse 259",
    cx: 3.801,
    cy: 3.801,
    r: 3.801,
    transform: "translate(662.285 665.934)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287-3078",
    "data-name": "Path 1287",
    d: "M93.8,609.732H92.07V608h-.338v1.732H90v.338h1.731V611.8h.338V610.07H93.8Z",
    transform: "translate(515.266 140.137)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288-3079",
    "data-name": "Path 1288",
    d: "M678.8,461.731H677.07V460h-.338v1.731H675v.338h1.732V463.8h.338V462.07H678.8Z",
    transform: "translate(486.205 147.489)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289-3080",
    "data-name": "Path 1289",
    d: "M829.8,431.731H828.07V430h-.338v1.731H826v.338h1.732V433.8h.338V432.07H829.8Z",
    transform: "translate(478.704 148.979)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290-3081",
    "data-name": "Path 1290",
    d: "M504.8,511.731H503.07V510h-.338v1.731H501v.338h1.731V513.8h.338V512.07H504.8Z",
    transform: "translate(494.849 145.005)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291-3082",
    "data-name": "Path 1291",
    d: "M785.8,521.732H784.07V520h-.338v1.732H782v.338h1.732V523.8h.338V522.07H785.8Z",
    transform: "translate(480.89 144.509)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292-3083",
    "data-name": "Path 1292",
    d: "M446.8,564.732H445.07V563h-.338v1.732H443v.338h1.732V566.8h.338V565.07H446.8Z",
    transform: "translate(497.729 142.373)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293-3084",
    "data-name": "Path 1293",
    d: "M574.8,566.732H573.07V565h-.338v1.732H571v.338h1.732V568.8h.338V567.07H574.8Z",
    transform: "translate(491.371 142.273)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294-3085",
    "data-name": "Path 1294",
    d: "M95.8,396.731H94.07V395h-.338v1.731H92v.338h1.731V398.8h.338V397.07H95.8Z",
    transform: "translate(515.166 150.718)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1295-3086",
    "data-name": "Path 1295",
    d: "M480.8,380.731H479.07V379h-.338v1.731H477v.338h1.731V382.8h.338V381.07H480.8Z",
    transform: "translate(496.041 151.513)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296-3087",
    "data-name": "Path 1296",
    d: "M644.8,324.731H643.07V323h-.338v1.731H641v.338h1.732V326.8h.338V325.07H644.8Z",
    transform: "translate(487.894 154.295)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1297-3088",
    "data-name": "Path 1297",
    d: "M626.8,341.732H625.07V340h-.338v1.732H623v.338h1.732V343.8h.338V342.07H626.8Z",
    transform: "translate(488.788 153.45)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_260",
    "data-name": "Ellipse 260",
    cx: 3.801,
    cy: 3.801,
    r: 3.801,
    transform: "translate(1044.315 447.36)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1298-3089",
    "data-name": "Path 1298",
    d: "M982.911,290.71h-1.9a78.007,78.007,0,0,0,77.917,77.489v-1.9A76.1,76.1,0,0,1,982.911,290.71Z",
    transform: "translate(340.81 97.691)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1299-3090",
    "data-name": "Path 1299",
    d: "M945.911,290.71h-1.9a113.2,113.2,0,0,0,113.079,112.651v-1.9A111.3,111.3,0,0,1,945.911,290.71Z",
    transform: "translate(342.647 97.691)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300-3091",
    "data-name": "Path 1300",
    d: "M907.9,290.71H906c.238,82.07,67.074,148.764,149.2,148.764v-1.9C974.119,437.573,908.138,371.735,907.9,290.71Z",
    transform: "translate(344.535 97.691)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301-3092",
    "data-name": "Path 1301",
    d: "M660.318,67.053S635.9,45.16,603.06,86.42s-84.2,61.468-95.992,77.467c0,0,48.838-20.209,65.679-28.629s16-6.736,16-6.736-22.735,16-26.945,32-.842,29.471-8.42,45.47,144.83,10.946,144.83,10.946,15.157-26.1,10.946-53.048S707.472,70.421,660.318,67.053Z",
    transform: "translate(364.353 109.09)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302-3093",
    "data-name": "Path 1302",
    d: "M617.984,139.83s5.31,37.169-17.447,45.513-14.413,19.722-14.413,19.722l34.135,16.688,36.411-11.378,12.137-18.205s-19.722-4.551-14.413-18.205,6.827-18.205,6.827-18.205Z",
    transform: "translate(360.5 105.187)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304-3094",
    "data-name": "Path 1304",
    d: "M718.676,251.578s-5.31,69.787-3.793,72.821,0,108.473,0,108.473,10.62,56.891-3.034,59.926-10.62-63.718-10.62-63.718l-13.654-87.992,1.517-87.234Z",
    transform: "translate(355.386 99.636)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305-3095",
    "data-name": "Path 1305",
    d: "M718.676,251.578s-5.31,69.787-3.793,72.821,0,108.473,0,108.473,10.62,56.891-3.034,59.926-10.62-63.718-10.62-63.718l-13.654-87.992,1.517-87.234Z",
    transform: "translate(355.386 99.636)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306-3096",
    "data-name": "Path 1306",
    d: "M563.382,472.681S538.35,567.5,539.109,613.772s10.62,110.749,10.62,110.749,1.517,28.066-.759,31.1,11.378,15.93,11.378,15.93l14.413-8.344,5.31-6.068v-5.31s-8.344-25.791-1.517-46.272,10.62-72.062,3.793-87.992l47.03-139.574Z",
    transform: "translate(362.762 88.652)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307-3097",
    "data-name": "Path 1307",
    d: "M560.459,773.964s-9.1-11.378-15.171-7.586-15.93,29.584-15.93,29.584S495.223,828.58,519.5,830.1s34.893-6.827,37.928-12.9,31.1-22,31.1-22-3.034-28.825-7.585-29.584S569.561,777,569.561,777Z",
    transform: "translate(364.168 74.102)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308-3098",
    "data-name": "Path 1308",
    d: "M651.1,477.877v94.061a290.858,290.858,0,0,0,2.276,34.135c2.276,16.688-12.9,141.091-12.9,141.091l1.517,22,18.964-1.517,2.276-18.964,27.308-83.441s9.1-50.823,4.551-69.787S718.612,455.12,718.612,455.12Z",
    transform: "translate(357.726 89.524)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309-3099",
    "data-name": "Path 1309",
    d: "M635.608,779.535l5.618-1.221s4.243-9.4,9.553-7.123a57.265,57.265,0,0,1,10.558,6.327l2.337,4.293s5.31,11.378,12.137,18.964,14.413,24.274,3.034,25.791-26.549,2.276-31.1-1.517-1.517-9.861-6.068-11.378-8.344-6.068-7.585-7.586S635.608,779.535,635.608,779.535Z",
    transform: "translate(358.048 73.841)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_261",
    "data-name": "Ellipse 261",
    cx: 33.713,
    cy: 33.713,
    r: 33.713,
    transform: "translate(975.113 203.718)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310-3100",
    "data-name": "Path 1310",
    d: "M584.607,193.925l10.02-3.5s-3.951,6.532,17.288,10.325,43.235,5.136,53.1-7.293c0,0,3.794-1.809,9.1,3.5s8.344,3.793,8.344,3.793l-3.793,19.722-7.586,36.411-9.861,27.308-28.066-6.068-30.342-22-11.378-29.584V199.235Z",
    transform: "translate(360.501 102.673)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311-3101",
    "data-name": "Path 1311",
    d: "M675.168,204.692l7.586-5.31s25.791,4.551,27.308,16.688L690.339,254a43.18,43.18,0,0,1-.759,32.618c-7.586,17.447-6.827,21.24-6.827,21.24l-5.31,22.757L581.107,338.2s-3.793-9.1-5.31-10.62-1.517-6.827,0-6.827,0-2.276-1.517-4.551-2.276-3.034,0-6.068-3.793-30.342-3.793-30.342V250.205L544.7,216.07s9.1-13.654,13.654-15.171,26.2-7.5,26.2-7.5l4.9,7.213,6.827,54.9,9.861,33.376,41.521-7.055,16.129-27.08,10.62-31.859Z",
    transform: "translate(362.483 102.526)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312-3102",
    "data-name": "Path 1312",
    d: "M711.327,212.466l6.068,4.551s5.31,42.479,3.793,45.513-28.066,6.068-28.825,4.551S711.327,212.466,711.327,212.466Z",
    transform: "translate(355.149 101.579)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313-3103",
    "data-name": "Path 1313",
    d: "M579.545,189.958l7.586,50.064s-6.827,74.338-5.31,89.509l1.517,4.551s-3.034-1.517-3.793,1.517,0,12.9,0,12.9-4.551,4.551-6.068,29.584-19.722,84.958-12.9,87.234,47.789,13.654,69.787,11.378S731.256,447.866,730.5,441.039s-38.686-103.163-38.686-103.163-6.827-11.378-6.827-12.9,9.1-7.586,6.827-13.654S677.4,241.539,677.4,241.539l8.344-45.513-11.378-3.034-8.344,44s-32.618,15.93-66.753,1.517l-7.586-51.582Z",
    transform: "translate(361.771 102.847)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314-3104",
    "data-name": "Path 1314",
    d: "M619.02,105.6s56.133,38.686,71.3,21.239-26.549-32.618-26.549-32.618l-34.893-3.793Z",
    transform: "translate(358.791 107.641)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315-3105",
    "data-name": "Path 1315",
    d: "M539.1,261.157s5.31,69.787,3.793,72.821,0,108.473,0,108.473-10.62,56.891,3.034,59.926,10.62-63.718,10.62-63.718L570.2,350.666l-1.517-87.234Z",
    transform: "translate(362.769 99.16)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316-3106",
    "data-name": "Path 1316",
    d: "M550.3,214.861l-6.068,2.276s-11.378,47.789-8.344,47.789,39.445,4.551,39.445,3.034-6.827-38.686-6.827-38.686Z",
    transform: "translate(362.946 101.459)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_262",
    "data-name": "Ellipse 262",
    cx: 9.773,
    cy: 9.773,
    r: 9.773,
    transform: "translate(744.93 561.333)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_263",
    "data-name": "Ellipse 263",
    cx: 9.773,
    cy: 9.773,
    r: 9.773,
    transform: "translate(1163.105 628.711)",
    fill: "#6c63ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactImg);
export default __webpack_public_path__ + "static/media/contact-img.41e0da5eac5397a89611a18d6bf0b874.svg";
export { ForwardRef as ReactComponent };